import React from "react";
import { useLanguageTranslation } from "../../../../hooks/useLanguageTranslation";
import { convertStringToArray } from "../../../../Utils/utils";
import PdfZipItem from "../../../../components/PdfZipItem";

const NeepcoCSRCommunity = ({ data }) => {
  const { getText } = useLanguageTranslation();

  const pdfArray = convertStringToArray(data?.field_download);

  return (
    <>
      <div className="mt-4">
        <h2 className="title3">{data?.title}</h2>
      </div>
      <div className="table-responsive">
        <table className="table table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>{getText("S.No.", "क्र. सं.")}</th>
              <th>{getText("Description", "विवरण")}</th>
              <th>{getText("Download", "डाउनलोड")}</th>
            </tr>
          </thead>
          <tbody>
            {pdfArray.map((item, index) => (
              <tr key={index}>
                <td data-key={getText("S.No.", "क्र. सं.")}>{index + 1}</td>
                <td data-key={getText("Description", "विवरण")}>{item.title}</td>
                <td data-key={getText("Download", "डाउनलोड")}>
                  <PdfZipItem
                    filePath={item?.file_path}
                    filesize={item?.file_size}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default NeepcoCSRCommunity;
